import React from 'react'
import { NavLink } from 'react-router-dom'

import { AccountModel } from 'api/http/models'
import { ItemType } from 'antd/lib/menu/hooks/useItems'
import { NAV_LINK_NAMES } from 'shared/consts'
import { getDisplayName } from 'shared/utils'

import {
    getAdminMenuItem,
    getMenuItem,
    getPartnerMenuItem,
    getProfileMenuItem,
} from './Header.consts'
import { ProfileLabel } from './ProfileLabel'
import menuTranslations from './translations'

/**
 * Собирает items для главного меню в зависимости от роли пользователя
 * и языка.  Все labels берутся из `translations.ts` (7 языков).
 *
 * @param accountData — текущий пользователь (или undefined для guest)
 * @param language    — текущий язык (en/es/ru/hy/fr/de/it)
 */
export const getMenuList = (
    accountData?: AccountModel,
    language = 'en'
): ItemType[] => {
    const t = menuTranslations[language] || menuTranslations.en

    const menuList: ItemType[] = [
        {
            label: t.autoTrading,
            key: 'autoTrading',
            children: [
                {
                    label: (
                        <NavLink to={NAV_LINK_NAMES.GLOBAL_MARKETS}>
                            {t.globalMarkets}
                        </NavLink>
                    ),
                    key: 'globalMarkets',
                },
                {
                    label: (
                        <NavLink to={NAV_LINK_NAMES.CRYPTO_MARKETS}>
                            {t.cryptoMarkets}
                        </NavLink>
                    ),
                    key: 'cryptoMarkets',
                },
            ],
        },
    ]

    if (accountData?.id) {
        menuList.push(...getMenuItem(t))
        if (accountData.isAdmin) {
            menuList.push(...getAdminMenuItem(t))
        }
        if (accountData.isPartner) {
            menuList.push(...getPartnerMenuItem(t))
        }
    }

    menuList.push({
        label: <NavLink to={NAV_LINK_NAMES.PREMIUM}>{t.premium}</NavLink>,
        key: 'premium',
    })

    menuList.push({
        label: <NavLink to={NAV_LINK_NAMES.GUIDES}>{t.guides}</NavLink>,
        key: 'guides',
    })

    if (accountData?.id) {
        menuList.push(
            ...getProfileMenuItem(
                t,
                <ProfileLabel name={getDisplayName(accountData)} />
            )
        )
    }

    return menuList
}
